import {SelectItem, SelectPopover, SelectArrow, SelectList, ComboboxList} from '@ariakit/react'
import styled, {css} from 'styled-components'
import {Button} from '@components/ui/button/Button'

export const StyledSelectPopover = styled(SelectPopover)`
    ${({theme}) => css`
        padding: ${theme.spacing}px ${theme.spacing * 1.5}px;
        max-height: var(--popover-available-height);
        overflow-y: auto;
        overflow-x: hidden;
        display: grid;
        grid-template-rows: auto 1fr;
        gap: ${theme.spacing}px;
        z-index: ${theme.zIndex.dropdown};

        min-width: 200px;
        max-width: 400px;
        width: auto;
    `}
`

export const StyledSelectComboboxPopover = styled(StyledSelectPopover)(
    ({theme: {spacing}}) => css`
        display: grid;
        grid-template-rows: auto minmax(0, 1fr);
        gap: ${spacing}px;
    `
)

export const StyledSelectList = styled(SelectList)`
    overflow-y: auto;
`
export const StyledSelectComboboxList = styled(ComboboxList)`
    overflow-y: auto;
`

export const StyledSelectItem = styled(SelectItem)`
    ${({theme}) => css`
        display: flex;
        align-items: center;
        gap: ${theme.spacing * 2}px;
        padding: ${theme.spacing * 2.5}px ${theme.spacing * 3.5}px;
        cursor: pointer;
        border-radius: 6px;
        margin: 1px 0;
        color: ${theme.palette.neutral[900]};
        font-weight: 500;
        position: relative;

        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 100%;

        &:hover {
            background-color: ${theme.palette.neutral['100']};
        }

        &:hover::after {
            visibility: visible;
            opacity: 1;
        }

        white-space: normal;
        word-wrap: break-word;
        max-width: 100%;
    `}
`

export const StyledSelectTrigger = styled(Button)<{$hasChildren: boolean}>(
    ({theme: {palette}, $hasChildren}) => css`
        justify-content: space-between;
        ${!$hasChildren &&
        css`
            font-weight: 400;
            color: ${palette.neutral['400']};
        `};

        &:not(:disabled):hover,
        &:focus,
        &[aria-expanded='true'] {
            outline: 1px solid ${palette.primary[300]};
            box-shadow: 0 0 0 4px ${palette.primary[100]};
        }
        &:disabled {
            background-color: ${palette.neutral['100']};
        }

        @media (max-width: 768px) {
            width: 100%;
            justify-content: center;
        }
    `
)

export const StyledSelectArrow = styled(SelectArrow)<{$isOpen: boolean}>(
    ({theme: {transition, palette}, $isOpen}) => css`
        fill: ${palette.neutral[500]};
        transition: ${transition};
        margin-left: auto;
        ${$isOpen &&
        css`
            transform: rotate(180deg);
        `}
    `
)
